export const PriceDetailsWrapperFragment = `
    ... on PriceDetails {
        checkoutUrl
        edapEventJson
        lineItems {
            amount
            subItems {
                amount
                link
                linkText
                tooltip
                title
                type
                subItems {
                    title
                    amount
                }
            }
            discountTitle
            link
            linkText
            mixedCurrencyDisclaimer
            title
            tooltip
            type
        }
        notes {
            description
        }
        payments {
            amount
            infoText
            paidText
            status
            title
            viewUrl
        }
        totals {
            amount
            title
            tooltip
            subItems {
                title
            }
            currencyCode
        }
        vasItems {
            amount
            infoText
            paidText
            status
            title
            vasPaymentDetails {
                type
            }
            viewUrl
        }
        failedInsurtechItems {
            title
            status
            vasPaymentDetails {
                type
            }
        }
        notes{
            description
        }
        loyalty {
            accountDetails {
                tier {
                    key
                    name
                }
            }
            labels {
                usedBurnLabel
                earnRewardsLabel
                viewRewardsLabel
                awardBreakdownLabels {
                    awardBreakdownSummaryLabel
                    breakdownLabels
                }
            }
            totalsWithBurn {
                title
                amount
            }
            paymentsWithBurn {
                amount
                infoText
                paidText
                status
                title
                viewUrl
            }
        }
        loyaltyEligibleAmounts {
            siteFees
            sitePrice
            siteTaxes
        }
    }
`;
